module.exports = __webpack_public_path__ + "static/media/Venmo-mockup.034cf407.png";